import styled from 'styled-components'

import { Box } from 'pcln-design-system'

const StyledBox = styled(Box)`
  background-color: #f8f8f8;
  border-bottom: solid 1px #bfbfbf;
  border-top: solid 1px #bfbfbf;
  margin: 0 auto;

  @media only screen and (max-width: 767px) {
    text-align: center;
  }
`

StyledBox.displayName = 'StyledBox'

export default StyledBox
